import { useState } from 'react';
import { Link } from 'react-router-dom';
import logo from '../../assets/images/logo.png';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const handleNewsletter = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    setSubmitting(true);
    try {
      // TODO: Replace with actual newsletter API endpoint
      await new Promise((resolve) => setTimeout(resolve, 500));
      setSubmitted(true);
    } catch {
      setSubmitted(true);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <footer className="bg-[#0F0E0A] py-16 px-6 md:px-10">
      <div className="max-w-7xl mx-auto">
        <div className="bg-[#1A1915] rounded-2xl p-10 md:p-14 grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Newsletter */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-3 mb-6">
              <img
                src={logo}
                alt="Escala Equipe"
                className="w-8 h-8 object-contain"
              />
              <span className="text-white font-bold text-lg" style={{ fontFamily: "'Playfair Display', serif" }}>Escala Equipe</span>
            </div>
            <p className="text-white/40 text-sm leading-relaxed mb-6">
              A plataforma definitiva para músicos de louvor. Cifras, colaboração e performance em um só lugar.
            </p>
            {submitted ? (
              <p className="text-[#C8A96E] text-sm">Obrigado! Você está na lista.</p>
            ) : (
              <form
                data-readdy-form
                onSubmit={handleNewsletter}
                className="flex flex-col gap-3"
              >
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="seu@email.com"
                  className="bg-transparent border-b border-white/20 text-white text-sm py-2 outline-none placeholder-white/30 focus:border-white/50 transition-colors"
                  required
                />
                <button
                  type="submit"
                  disabled={submitting}
                  className="bg-white text-[#0A0A0F] text-sm font-semibold px-6 py-2.5 rounded-full hover:bg-white/90 transition-colors whitespace-nowrap cursor-pointer w-fit"
                >
                  {submitting ? 'Enviando...' : 'Fique por dentro →'}
                </button>
              </form>
            )}
          </div>

          {/* Navigation */}
          <div>
            <p className="text-white/30 text-xs uppercase tracking-widest mb-5">Navegação</p>
            <div className="flex flex-col gap-3">
              {[
                { label: 'Home', to: '/' },
                { label: 'Planos', to: '/plans' },
                { label: 'Biblioteca', to: '/library' },
                { label: 'Colaboração', to: '/collab' },
              ].map((link) => (
                <Link
                  key={link.label}
                  to={link.to}
                  className="text-white/60 hover:text-white text-sm underline-offset-4 hover:underline transition-colors cursor-pointer"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <p className="text-white/30 text-xs uppercase tracking-widest mb-5">Contato</p>
            <div className="flex flex-col gap-2 mb-6">
              <a href="mailto:irawildaws@gmail.com" className="text-white/60 hover:text-white text-sm transition-colors cursor-pointer">irawildaws@gmail.com</a>
              <a href="https://wa.me/5511975093800" target="_blank" rel="noopener noreferrer" aria-label="Fale conosco pelo WhatsApp" className="text-white/60 hover:text-white text-sm transition-colors cursor-pointer">+55 (11) 97509-3800</a>
            </div>
            <p className="text-white/30 text-xs uppercase tracking-widest mb-3">Redes Sociais</p>
            <div className="flex gap-4">
              {['instagram-line', 'youtube-line', 'twitter-x-line', 'github-line'].map((icon) => (
                <a
                  key={icon}
                  href="#"
                  rel="nofollow"
                  className="w-8 h-8 flex items-center justify-center text-white/40 hover:text-white transition-colors cursor-pointer"
                >
                  <i className={`ri-${icon} text-lg`}></i>
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="flex flex-col sm:flex-row items-center justify-between mt-8 gap-4">
          <p className="text-white/20 text-xs">© 2026 Escala Equipe. Todos os direitos reservados.</p>
          <div className="flex gap-6">
            <a href="#" rel="nofollow" className="text-white/20 hover:text-white/50 text-xs underline-offset-4 hover:underline transition-colors cursor-pointer">Privacidade</a>
            <a href="#" rel="nofollow" className="text-white/20 hover:text-white/50 text-xs underline-offset-4 hover:underline transition-colors cursor-pointer">Termos de Uso</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
